var $li = $('<li/>').attr({
  class: 'mpp-box'
});

$(document).ready(function () {
  $('.mpp-tout').appendTo($li);
  var $productGrids = $('#mpp-product-grid li');

  $li.insertBefore($productGrids.eq(4));
  if ($productGrids.length < 4) {
    $li.insertAfter($productGrids.eq(2));
  }
  if ($productGrids.length < 3) {
    $li.insertAfter($productGrids.eq(1));
  }
});
